import React, { FunctionComponent } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import {
  LineProgressComponentProps,
  CircleProgressComponentProps,
} from './ProgressComponents.types';
import './ProgressComponent.scss';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  barColorPrimary: {
    backgroundColor: (props: LineProgressComponentProps) =>
      props.customRootBarColor ? props.customRootBarColor.bar : '',
  },
  dashedColorPrimary: {
    backgroundImage: (props: LineProgressComponentProps) =>
      props.customRootBarColor
        ? `radial-gradient(${props.customRootBarColor.root} 0%, ${props.customRootBarColor.root} 16%, transparent 42%)`
        : '',
  },
  colorPrimary: {
    '&.MuiLinearProgress-determinate': {
      backgroundColor: (props: LineProgressComponentProps) =>
        props.customRootBarColor ? props.customRootBarColor.root : '',
    },
  },
});

export const LineProgressComponent: FunctionComponent<
  LineProgressComponentProps
> = props => {
  const {
    className,
    color = 'primary',
    label,
    value = 0,
    valueBuffer = 0,
    variant = 'buffer',
  } = props;
  const classes = useStyles(props);
  if (label) {
    return (
      <div className="line-progress-container">
        <LinearProgress
          classes={classes}
          className={clsx(className, 'progress-with-label')}
          variant={variant}
          value={value}
          valueBuffer={valueBuffer}
          color={color}
        />
        <span>{label}%</span>
      </div>
    );
  }
  return (
    <LinearProgress
      classes={classes}
      className={className}
      variant={variant}
      value={value}
      valueBuffer={valueBuffer}
      color={color}
    />
  );
};

export const CircleProgressComponent: FunctionComponent<
  CircleProgressComponentProps
> = props => {
  const {
    className,
    color = 'primary',
    disableShrink = false,
    label,
    size = 40,
    thickness = 3.6,
    value = 0,
    variant = 'static',
  } = props;
  if (label) {
    return (
      <div className="circle-progress-container" style={{ width: `${size}px` }}>
        <CircularProgress
          className={clsx(className, 'progress-with-label')}
          disableShrink={disableShrink}
          size={size}
          thickness={thickness}
          variant={variant}
          value={value}
          color={color}
        />
        <div className="label-container">
          <span style={{ fontSize: `${size / 6}px` }}>{label}</span>
        </div>
      </div>
    );
  }
  return (
    <CircularProgress
      className={className}
      disableShrink={disableShrink}
      size={size}
      thickness={thickness}
      variant={variant}
      value={value}
      color={color}
    />
  );
};
